import { render, staticRenderFns } from "./CounterDisplay.vue?vue&type=template&id=1ef829a9&scoped=true"
import script from "./CounterDisplay.vue?vue&type=script&lang=js"
export * from "./CounterDisplay.vue?vue&type=script&lang=js"
import style0 from "./CounterDisplay.vue?vue&type=style&index=0&id=1ef829a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef829a9",
  null
  
)

export default component.exports